import { FileLogger } from "./file.logger";

class CustomLogger extends FileLogger {
}

/**
 * Function that returns a logger to specified folder, and a given filename
 * @param {string} fileName fileName to log into
 * @param {string} prefix prefix for all logs to start with
 * @param {boolean} normalDebug wether to write logs using normal debug module as well as file
 * @param {string} fileLocation log file location inside ./log
 * @returns
 */
export const customLogger = (fileName: string, prefix: string, normalDebug = false, fileLocation: string = CustomLogger.DEFAULT_RELATIVE_FILE_LOCATION): CustomLogger => new CustomLogger(fileName, prefix, normalDebug, fileLocation);
